/**
 * Sets --ronys-reels-offset to the space the announcement bar + header take
 * above the feed (they're in normal flow, not overlaid), so each panel's
 * `100svh - offset` actually fills the remaining screen instead of
 * overflowing past the fold by that amount.
 */
(function () {
  function setOffset() {
    document.querySelectorAll('[data-ronys-reels]').forEach(function (el) {
      var offset = el.getBoundingClientRect().top + window.scrollY;
      document.documentElement.style.setProperty('--ronys-reels-offset', offset + 'px');
    });
  }

  setOffset();
  window.addEventListener('load', setOffset);
  window.addEventListener('resize', setOffset);

  /**
   * Auto-advances the feed one panel every 4s, starting immediately on the
   * intro (it's now styled just like a product panel -- photo + bottom-left
   * text, see the section's markup -- so waiting on it behaves the same as
   * waiting on any other panel) and looping back to it after the last one.
   * Any interaction (wheel/touch/pointer/key) stops it for good -- once the
   * visitor is steering, it never fights them for control again. Skipped
   * entirely under prefers-reduced-motion.
   */
  function initAutoplay(container) {
    var panels = Array.prototype.slice.call(container.querySelectorAll('.ronys-reels__panel'));
    if (panels.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var interactionEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];

    function currentIndex() {
      return Math.round(container.scrollTop / container.clientHeight);
    }

    function goNext() {
      var idx = currentIndex();
      var nextIndex = (idx + 1) % panels.length;
      panels[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var timer = window.setInterval(goNext, 4000);

    function stopAutoplay() {
      window.clearInterval(timer);
      interactionEvents.forEach(function (evt) {
        container.removeEventListener(evt, stopAutoplay);
      });
    }

    interactionEvents.forEach(function (evt) {
      container.addEventListener(evt, stopAutoplay, { passive: true });
    });
  }

  /**
   * Crossfades the intro panel's optional real-portrait carousel (the
   * section's "Real portrait photo" blocks) every 3.5s -- independent of
   * initAutoplay above, which moves between PANELS; this moves between
   * SLIDES within the single intro panel. Does nothing if the merchant
   * hasn't added at least 2 photo blocks. Also skipped under
   * prefers-reduced-motion (first slide just stays put).
   */
  function initHeroCarousel(container) {
    var slides = Array.prototype.slice.call(container.querySelectorAll('.ronys-reels__carousel-slide'));
    if (slides.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var index = 0;
    window.setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 3500);
  }

  document.querySelectorAll('[data-ronys-reels]').forEach(initAutoplay);
  document.querySelectorAll('[data-ronys-hero-carousel]').forEach(initHeroCarousel);
})();
